export default __webpack_public_path__ + "static/media/LogoKemenduk.d9ac48d3.png";